import { ClientContactData } from '@modules/EvaluationModule/interfaces/ClientSubProjectData';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClientWorkstreamContactsData } from '../redux/actions';
import { clientWorkstreamContactsDataSelector } from '../redux/selectors';
import { AsyncData } from '@shared/interfaces/asyncData';
import { DataState } from '@shared/enums/DataState';
import { CONTACTS_CACHE_TTL_MS } from '../cacheConstants';

export const useClientWorkstreamData = (project: {
  workstreamId: string | null;
  clientId: string | null;
  enabled?: boolean;
}): AsyncData<ClientContactData[]> => {
  const clientWorkstreamContactsData = useSelector(clientWorkstreamContactsDataSelector(project));
  const dispatch = useDispatch();
  const enabled = project.enabled !== undefined ? project.enabled : true;

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (project.workstreamId === null && project.clientId === null) {
      return;
    }
    const { state, fetchedAt } = clientWorkstreamContactsData;
    const isFresh =
      state === DataState.Fulfilled && fetchedAt !== null && Date.now() - fetchedAt < CONTACTS_CACHE_TTL_MS;
    if (isFresh) {
      return;
    }

    dispatch(getClientWorkstreamContactsData(project));
    // No unmount cleanup: data is keyed by workstream id in the store, so there is nothing to
    // undo, and resetting it to Pending here was what caused a refetch + skeleton flash on every
    // toggle/navigation (F-B2).
  }, [project.clientId, project.workstreamId, enabled]);

  return clientWorkstreamContactsData;
};
